module.exports = "https://trybtryb-legacy.web.app/img/candy.f2f96cc4.webp";